import { action, computed, makeObservable, observable } from 'mobx';
import AutoReply from '../models/autoReply';
import processIncomingData from '../processIncomingData';
import * as utils from '../../helpers/utils';

class AutoReplyStore {
  constructor(rootStore) {
    makeObservable(this);
    this.rootStore = rootStore;
  }

  @observable autoReplies = [];

  @computed get getWorkingHoursSmsAutoReplies() {
    return this.autoReplies.filter(
      (f) => f.AutoReplyType?.TypeId === utils.AutoReplyTypeEnum.WorkingHoursSMS.TypeId
    );
  }

  @computed get getWorkingHoursWebChatAutoReplies() {
    return this.autoReplies.filter(
      (f) => f?.AutoReplyType?.TypeId === utils.AutoReplyTypeEnum.WorkingHoursWebChat.TypeId
    );
  }

  @action UpsertAndGet(incObj) {
    return processIncomingData(incObj, this.rootStore, this.autoReplies, AutoReply);
  }
}

export default AutoReplyStore;
